<ng-container>
    <div class="rental-requests-modal">
        <h1 class="theme-heading">{{ 'OnlinePaymentHistoryForContract' | translate }} # {{contractDetail?.[0]?.Id}}</h1>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <th>{{ 'PaidOnDate' | translate }}</th>
                    <th>{{ 'TotalOnlinePayment' | translate }}</th>
                    <th>{{ 'ReferenceNumber' | translate }}</th>
                    @if (isPaymentMethodAvailable()) {
                    <th>{{ 'PaymentMethod' | translate }}</th>
                    }
                    <th>{{ 'Processed' | translate }}</th>
                </thead>
                <tbody>
                    @for (receivedPayment of contractDetail?.[0]?.Payment; track receivedPayment) {
                    <tr>
                        <td class="text-center">{{ receivedPayment.PaidDateTime | formatDate : featureToggleService.isSyrinx() }}</td>
                        <td class="text-center">{{ receivedPayment.TotalPaid | formatCurrency }}</td>
                        <td class="text-center">{{ receivedPayment.ReferenceNumber }}</td>
                        @if (isPaymentMethodAvailable()) {
                        <td class="text-center">{{ appMediatorService.porPayService.getPaymentMethod(receivedPayment.PaymentMethod) }}</td>
                        }
                        <td class="text-center">
                            @switch (receivedPayment.Consumed) { @case (consumed.Imported) {
                            {{ 'Imported' | translate }}
                            } @case (consumed.Posted) {
                            {{ 'Posted' | translate }}
                            } @case (consumed.Error) {
                            {{ 'Error' | translate }}
                            } @default {
                            {{ 'Waiting' | translate }}
                            } }
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
